import styled from 'styled-components';

const InputBox = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: 100%;

  padding: 0 12px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  column-gap: 8px;
  cursor: text;

  transition: background-color 0.1s 0.05s ease, box-shadow 0.1s 0s ease, border-color 0.1s ease;

  background-color: transparent;
  border-color: var(--border-muted);

  &:hover {
    background-color: var(--elevation-indented);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 3px 0 inset;
  }

  &:focus-within {
    background-color: var(--white);
    box-shadow: 0 4px 6px 0 var(--wash-orange-hover);
    border-color: var(--primary-default);
  }
`;

export { InputBox };
